import { configureStore } from '@reduxjs/toolkit'
import navbarReducer from './navbarSlice'
import countriesReducer from './countriesSlice'
import daypartsReducer from './daypartsSlice'
import mealpartsReducer from './mealpartsSlice'
import brandsReducer from './brandsSlice'
import presentationsReducer from './presentationsSlice'
import savedSearchesReducer from './savedSearchesSlice'
import conceptsReducer from './conceptsSlice'
import userReducer from './userSlice'

//import logger  from 'redux-logger'

export const store = configureStore({
    reducer: {
        navbar: navbarReducer,
        countries: countriesReducer,
        dayparts: daypartsReducer, 
        mealparts: mealpartsReducer,
        brands: brandsReducer,
        presentations: presentationsReducer,
        savedSearches: savedSearchesReducer,
        concepts: conceptsReducer,
        user: userReducer,
    }
})
